const BuyFuelStatus = {
  Success: "success",
  Voided: "voided",
};

export default BuyFuelStatus;
